import type { IUsageFeeTier } from '../types';

import { IUsageFeeTierKey } from '../types';
import { create } from 'zustand';

export interface IUsageFeeTierStoreState {
  usageFeeTiers?: IUsageFeeTier[];
  /**
   * @default: IUsageFeeTierKey.BASIC
   */
  activeUsageFeeTierKey: IUsageFeeTierKey;
}

export interface IUsageFeeTierStoreActions {
  setUsageFeeTiers: (value: IUsageFeeTier[]) => void;
  setActiveUsageFeeTierKey: (value: IUsageFeeTierKey) => void;
}

export const useUsageFeeTierStore = create<IUsageFeeTierStoreState & IUsageFeeTierStoreActions>()(
  (set) => ({
    usageFeeTiers: undefined,
    activeUsageFeeTierKey: IUsageFeeTierKey.BASIC,

    setUsageFeeTiers: (val: IUsageFeeTier[]) => {
      set(() => ({ usageFeeTiers: val }));
    },
    setActiveUsageFeeTierKey: (val: IUsageFeeTierKey) => {
      set(() => ({ activeUsageFeeTierKey: val }));
    },
  }),
);
